import {
	Card,
	Row,
	Col,
	Image
} from 'react-bootstrap'
import styles from '../styles/Event.module.scss'
import { useRouter } from 'next/router'

interface BoothProps {
  company?: any
  boothNum?: number
  eventId?: any
  institute?: any
}

const Booth: React.FC<BoothProps> = (props: BoothProps) => {
	const router = useRouter()
	const locale: string = router.locale as string
	const { boothNum, company, eventId, institute } = props
	if (typeof company !== 'undefined') {
		return (
			<a target='_blank' rel='noreferrer' href={`/${locale}/company/jobs/${company.id as string}-${eventId as string}`}>
				<Card className='mx-auto booth-no-card' style={{ marginTop: '20px'}}>
					<Card.Header className={styles.boothNumContainer} ><strong>Booth {boothNum}</strong></Card.Header>
				</Card>
				<div className='booth'>
					<Row className='justify-content-center'>
						<Col xs={6}>
							<Row className='justify-content-center'>
								<Col xs={6} md={4} style={{ zIndex: 9999 }}>
									<div className='mx-auto hanger' />
								</Col>
								<Col xs={6} md={4} style={{ zIndex: 9999 }}>
									<div className='mx-auto hanger' />
								</Col>
							</Row>
						</Col>
					</Row>
					<Card className='mx-auto booth-content-card' style={{ marginTop: '-10px', zIndex: 0, borderLeft: '1px solid lightgray', borderRight: '1px solid lightgray', borderBottom: '10px solid lightgray' }}>
						<Card.Header style={{ backgroundColor: '#FFF4E8', border: '1px solid lightgray' }} />
						<Card.Body className='text-center' style={{ paddingBottom: '10px' }}>
							<br className='d-none d-sm-block' />
							<div className='container w-100 d-none d-sm-block d-flex flex-wrap align-items-center' style={{ height: '80px' }}>
								{/* <div className='row mx-auto justify-content-center align-self-center booth-company-avatar' style={{ border: '1px solid #FFF4E8', borderRadius: '40px', overflow: 'hidden' }}> */}
								<Image style={{ height: 'auto', objectFit: 'cover', maxHeight: '80px' }} src={company.avatar} alt='' />
								{/* </div> */}
							</div>
							<div className='container d-flex h-100 d-block d-sm-none'>
								<div className='w-100 d-flex flex-wrap align-items-center' style={{ height: '50px' }}>
									<Image style={{ width: '100%', height: 'auto', objectFit: 'cover' }} src={company.avatar} alt='' />
								</div>
							</div>
							<br />
							{/* <br className='d-none d-sm-block' /> */}
							<h2 className={styles.name}>{company.name}</h2>
						</Card.Body>
					</Card>
				</div>
			</a>
		)
	} else {
		return (
			<a target='_blank' rel='noreferrer' href={`/${locale}/courses/ecda/${institute.id}`}>
				<div className='booth'>
					<Card
						// className={styles.boothCard}
						className='mx-auto booth-content-card' style={{ marginTop: '20px', zIndex: 0, borderLeft: '1px solid lightgray', borderRight: '1px solid lightgray', borderBottom: '10px solid lightgray' }}
					>
						<Card.Header
							// className={styles.boothCardHeader}
							style={{ backgroundColor: '#FFF4E8', border: '1px solid lightgray' }}
						/>
						<Card.Body className='text-center' style={{ overflow: 'hidden' }}>
							<br className='d-none d-sm-block' />
							<div className='container d-flex h-100'>
								<div className='row mx-auto justify-content-center align-self-center booth-company-avatar' style={{ border: '1px solid #FFF4E8', borderRadius: '40px', overflow: 'hidden' }}>
									<Image style={{ height: 'auto', objectFit: 'contain' }} src={institute.avatar} alt='' />
								</div>
							</div>
							<br /><br className='d-none d-sm-block' />
							<h2 className={styles.name}>{institute.name}</h2>
						</Card.Body>
					</Card>
				</div>
			</a>
		)
	}
}

export default Booth
